import React, { useState } from 'react'
import { toast } from 'react-toastify'
import classes from './Personal.module.css'

const Personal = ({ fullName, api, id, token, setFullName, email, setEmail, phone, setPhone }) => {
    const toastError = () => {
        toast.dismiss()
        toast.error('Something went wrong!', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const toastSuccess = () => {
        toast.dismiss()
        toast.success('Form Updated!', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const response = await fetch(`${api}/users/${id}`, {
            headers: {
                Accept: 'appllication/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            body: JSON.stringify({
                name: fullName,
                phone: phone,
                email: email,
            }),
        })
        if (response.ok) {
            toastSuccess()
        } else {
            toastError()
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className={classes.wrapper}>
                <h1>Personal Information</h1>
                <div className={classes.innerContainer}>
                    {/* ---------------- */}
                    <div className={classes.formGroup}>
                        <label>Full Name</label>
                        <input
                            placeholder="Full Name"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                        />
                    </div>
                    {/* ---------------- */}
                    <div className={classes.half}>
                        <div className={classes.formGroup}>
                            <label>Email</label>
                            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className={classes.formGroup}>
                            <label>Phone</label>
                            <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className={classes.submit}>
                    <button>Submit</button>
                </div>
            </div>
        </form>
    )
}

export default Personal
